export enum Platform {
  IC2 = "IC2",
}
